import type { Auth0ClientLike } from './store/session/types';

let registeredAuth0Client: Auth0ClientLike | null = null;

export const registerAuth0Client = (client: Auth0ClientLike | null) => {
  registeredAuth0Client = client;
};

export const getRegisteredAuth0Client = (): Auth0ClientLike | null => {
  return registeredAuth0Client;
};
